import * as Yup from "yup"; // Import Yup
import { passwordRegex } from "../../lib/constants/regexConstant";

// {
//   password
//   confirmPassword
// }

const resetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .matches(passwordRegex, "Password must be at least 6 characters, contain at least one letter and one number"), // Regex for password
  confirmPassword: Yup.string()
    .required("Password is required")
    .oneOf([Yup.ref("password")], "Passwords must match!")
});

export default resetPasswordValidationSchema;
